import { Text } from "@merge-api/merge-javascript-shared";
import { ReactNode } from "react";
import GradientIcon from "../../shared/icons/GradientIcon";
import { CloudMoon, LucideIcon } from "lucide-react";
interface IntegrationBuilderEmptyStateProps {
  title: string;
  subtitle: string | ReactNode;
  numberOfColumns: number;
  withIcon?: boolean;
  icon?: LucideIcon;
}

const IntegrationBuilderEmptyState = ({
  title,
  subtitle,
  numberOfColumns,
  withIcon = false,
  icon = CloudMoon,
}: IntegrationBuilderEmptyStateProps) => {
  return (
    <tr>
      <td colSpan={numberOfColumns}>
        <div className="flex flex-col text-center items-center justify-center align-middle p-4 min-h-[280px]">
          {withIcon && (
            <GradientIcon
              Icon={icon}
              size={32}
              endColor="#2DB9EE"
              startColor="#0042E5"
              className="mb-4"
            />
          )}
          <Text className="mb-1 text-gray-40" variant="h4">
            {title}
          </Text>
          <Text className="text-gray-40" variant="sm">
            {subtitle}
          </Text>
        </div>
      </td>
    </tr>
  );
};
export default IntegrationBuilderEmptyState;
